export const KaiwaMetadata = {
    "1": {
        "speaker_relationship": "A,B,Cは知人で、北中城村文化協会しまくとぅば部のメンバー",
        "date": "2019年12月2日",
        "length": "1 hour",
        "location": "北中城中央公民館",
        "speakers": [
            {
                "code": "A", "sex": "女", "age": "79歳", "birthplace": "中城", "lived_in": ["中城・伊集","北中城・和仁屋"],
            },
            {
                "code": "B", "sex": "女", "age": "71歳", "birthplace": "北中城", "lived_in": ["北中城・和仁屋"],
            },
            {
                "code": "C", "sex": "女", "age": "71歳", "birthplace": "北中城", "lived_in": ["北中城・喜舎場"],
            }
        ]
    },
    "2": {
        "speaker_relationship": "A,B,Cは知人で、北中城村文化協会しまくとぅば部のメンバー",
        "date": "2019年12月9日",
        "length": "1 hour",
        "location": "北中城中央公民館",
        "speakers": [
            {
                "code": "A", "sex": "女", "age": "79歳", "birthplace": "中城", "lived_in": ["中城","北中城"],
            },
            {
                "code": "B", "sex": "女", "age": "71歳", "birthplace": "北中城", "lived_in": ["北中城・和仁屋"],
            },
            {
                "code": "C", "sex": "女", "age": "63歳", "birthplace": "北中城", "lived_in": ["北中城・喜舎場"],
            }
        ]
    },
    "3": {
        "speaker_relationship": "AとBは知人で、首里くとぅばの集いの会のメンバー",
        "date": "2019年3月28日",
        "length": "1 hour",
        "location": "沖縄芸術大学教室",
        "speakers": [
            {
                "code": "A", "sex": "男", "age": "78歳", "birthplace": "首里", "lived_in": ["那覇市・首里"],
            },
            {
                "code": "B", "sex": "女", "age": "80歳", "birthplace": "首里", "lived_in": ["那覇市・首里","石垣市"],
            }
        ]
    },
    "4": {
        "speaker_relationship": "A,B,C,Dは友人で同級生",
        "date": "2020年11月3日",
        "length": "1 hour",
        "location": "A自宅",
        "speakers": [
            {
                "code": "A", "sex": "男", "age": "66歳", "birthplace": "南城市", "lived_in": ["南城市・佐敷"],
            },
            {
                "code": "B", "sex": "男", "age": "65歳", "birthplace": "南城市", "lived_in": ["南城市・佐敷", "与那原町"],
            },
            {
                "code": "C", "sex": "男", "age": "65歳", "birthplace": "与那原町", "lived_in": ["与那原町","南城市・佐敷"],
            },
            {
                "code": "D", "sex": "男", "age": "66歳", "birthplace": "南城市", "lived_in": ["南城市", "南風原","本土"],
            }
        ]
    },
    "5": {
        "speaker_relationship": "AとBは知人で、沖縄語普及協議会のメンバー",
        "date": "2022年5月21日",
        "length": "1 hour",
        "location": "なは市民協働プラザ",
        "speakers": [
            {
                "code": "A", "sex": "女", "age": "81歳", "birthplace": "那覇市", "lived_in": ["那覇市・繁多川"],
            },
            {
                "code": "B", "sex": "女", "age": "74歳", "birthplace": "首里", "lived_in": ["那覇市・首里"],
            }
        ]
    },
    "6": {
        "speaker_relationship": "AとBは知人で、南城市文化協会・東方うちなぁぐち会のメンバー",
        "date": "2022年7月1日",
        "length": "1 hour",
        "location": "A自宅",
        "speakers": [
            {
                "code": "A", "sex": "男", "age": "66歳", "birthplace": "南城市", "lived_in": ["南城市・玉城・大里"],
            },
            {
                "code": "B", "sex": "男", "age": "70歳", "birthplace": "南城市", "lived_in": ["南城市・知念","宜野湾市"],
            }
        ]
    },
    "7": {
        "speaker_relationship": "AとBは知人で、Aは沖縄語普及協議会のメンバーで、BはAと共に小学校で普及活動に勤しむ。",
        "date": "2022年7月8日",
        "length": "1 hour",
        "location": "首里公民館",
        "speakers": [
            {
                "code": "A", "sex": "女", "age": "81歳", "birthplace": "首里", "lived_in": ["那覇市・首里"],
            },
            {
                "code": "B", "sex": "女", "age": "72歳", "birthplace": "首里", "lived_in": ["那覇市・首里"],
            }
        ]
    },
    "8": {
        "speaker_relationship": "AとBは知人で、沖縄語普及協議会のメンバー",
        "date": "2022年7月16日",
        "length": "1 hour",
        "location": "沖縄キリスト教学院大学",
        "speakers": [
            {
                "code": "A", "sex": "男", "age": "82歳", "birthplace": "首里", "lived_in": ["那覇市・首里"],
            },
            {
                "code": "B", "sex": "男", "age": "71歳", "birthplace": "首里", "lived_in": ["那覇市・首里"],
            }
        ]
    },
    "9": {
        "speaker_relationship": "AとBは知人で、沖縄語普及協議会のメンバー",
        "date": "2022年7月29日",
        "length": "1 hour",
        "location": "沖縄キリスト教学院大学",
        "speakers": [
            {
                "code": "A", "sex": "男", "age": "81歳", "birthplace": "南城市", "lived_in": ["南城市・佐敷"],
            },
            {
                "code": "B", "sex": "女", "age": "74歳", "birthplace": "首里", "lived_in": ["那覇市・首里"],
            }
        ]
    },
    "10": {
        "speaker_relationship": "AとBは知人で、沖縄語普及協議会のメンバー",
        "date": "2022年9月20日",
        "length": "1 hour",
        "location": "沖縄キリスト教学院大学",
        "speakers": [
            {
                "code": "A", "sex": "女", "age": "81歳", "birthplace": "那覇市", "lived_in": ["那覇市・繁多川"],
            },
            {
                "code": "B", "sex": "男", "age": "81歳", "birthplace": "那覇市", "lived_in": ["那覇市", "西原町"],
            }
        ]
    },
}